"use strict";

/**
 * @classdesc
 * Entfernt die aktuell ausgewählten Layer aus dem Layerbaum.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map Referenz auf die Karte der Layer
 */
gc.gis.action.layer.RemoveSelection = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.doRemove;
	/**
	 * @inheritdoc
	 */
	this.args = [options.map];
};
gc.gis.action.layer.RemoveSelection.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * Entfernt die aktuell ausgewählten Layer.
 * <em>Hinweis: Diese Funktion sollte nicht manuell aufgerufen werden.</em>
 *
 * @public
 * @param {gc.gis.map.GCMapView} map Referenz auf die Karte
 * @throws gc.gis.error.GCError wenn kein Layer ausgewählt ist oder das
 *   Entfernen schief geht
 * @see gc.gis.action.GCAbstractAction#execute
 */
gc.gis.action.layer.RemoveSelection.prototype.doRemove = function( map )
{
	var layers = map.getSelectedLayers();

	if( layers && layers.length > 0 )
	{
		for( var i=0; i<layers.length; i++ )
		{
			var parent_layer = layers[i].getParent();
			if( parent_layer )
			{
				parent_layer.removeLayer( layers[i] );
			}
			else
			{
				throw new gc.gis.error.GCError('Layer not attached to a parent');
			}
		}
	}
	else
	{
		gc.gis.iface.log.warn( this, 'Keine Ebenen ausgewählt!');
		//throw new gc.gis.error.GCError('Nothing selected');
	}
};

